import useCheckHesToken from "@/hooks/hes/useCheckHesToken";
import { Outlet, Navigate, useLocation } from "react-router-dom";

const HesOutlet = () => {
  const { pathname, search } = useLocation();
  const redirectUrl = `${pathname}${search}`;

  const validHesToken = useCheckHesToken();
  
    //redirect to /hes-auth screen if not valid Hes Token
    return validHesToken ? (
      <Outlet />
    ) : (
      <Navigate
        to="/hes-auth"
        replace
        state={{ redirectUrl: redirectUrl }}
      />
    );
};

export default HesOutlet;
